import React, { Fragment } from "react";
import "./input.css";

const Input = ({
  placeHolder,
  change,
  type,
  width,
  height,
  direction,
  value,
}) => {
  return (
    <Fragment>
      <input
        style={{ width: `${width}`, direction: `${direction}` }}
        onChange={change}
        type={type}
        placeholder={placeHolder}
        className="input_body"
        height={height}
        direction={direction}
        value={value}
      />
    </Fragment>
  );
};

export default Input;
